import React from 'react';

// Dashboard
const Home = React.lazy(() => import('pages/Home'));

// Ecommerce
const Checkout = React.lazy(() => import('pages/Ecommerce/Checkout'));
const CheckoutSuccess = React.lazy(
  () => import('pages/Ecommerce/CheckoutSuccess')
);
const CheckoutFailed = React.lazy(
  () => import('pages/Ecommerce/CheckoutFailed')
);
const Search = React.lazy(() => import('pages/Ecommerce/Products/Search'));
const Detail = React.lazy(() => import('pages/Ecommerce/Products/Detail'));

// Purchase
const CreateOtherPurchase = React.lazy(
  () => import('pages/Purchase/CreateOtherPurchase')
);
const OtherPurchaseRequest = React.lazy(
  () => import('pages/Purchase/OtherPurchaseRequest')
);
const PurchaseRequest = React.lazy(
  () => import('pages/Purchase/PurchaseRequest')
);

// Admin Purchase
const AdminCreateOtherPurchase = React.lazy(
  () => import('pages/Admin/Purchase/CreateOtherPurchase')
);
const AdminOtherPurchaseRequest = React.lazy(
  () => import('pages/Admin/Purchase/OtherPurchaseRequest')
);
const AdminPurchaseRequest = React.lazy(
  () => import('pages/Admin/Purchase/PurchaseRequest')
);

// PaymentList
const CreatePayment = React.lazy(() => import('pages/Payment/CreatePayment'));
const PaymentList = React.lazy(() => import('pages/Payment/PaymentList'));

// Auth - Create Password
const Login = React.lazy(() => import('pages/Authentication/Login'));
const Logout = React.lazy(() => import('pages/Authentication/LogOut'));
const Register = React.lazy(() => import('pages/Authentication/Register'));
const UserProfile = React.lazy(
  () => import('pages/Authentication/UserProfile')
);
const LoginSuccess = React.lazy(
  () => import('pages/Authentication/LoginSuccess')
);
const Pages404 = React.lazy(() => import('pages/AuthenticationInner/Pages404'));

// Admin
const AdminDashboard = React.lazy(() => import('pages/Admin/Dashboard/Dashboard'));

// Pages
const AboutUs = React.lazy(() => import('pages/Pages/AboutUs'));
const ContactUs = React.lazy(() => import('pages/Pages/ContactUs'));
const PrivacyPolicy = React.lazy(() => import('pages/Pages/PrivacyPolicy'));
const ReturnRefundPolicy = React.lazy(
  () => import('pages/Pages/ReturnRefundPolicy')
);
const ShippingPolicy = React.lazy(() => import('pages/Pages/ShippingPolicy'));
const TermsOfServices = React.lazy(() => import('pages/Pages/TermsOfServices'));

interface RouteObject {
  path: string;
  component: React.ComponentType<any>; // Use React.ComponentType to specify the type of the component
  exact?: boolean;
  isAdmin?: boolean;
}

const authProtectedRoutes: Array<RouteObject> = [
  // Ecommerce
  { path: '/search', component: Search },
  { path: '/product/:id', component: Detail },
  { path: '/ecommerce-product-overview', component: Detail },
  { path: '/ecommerce-checkout', component: Checkout },
  { path: '/ecommerce-checkout-success', component: CheckoutSuccess },
  { path: '/ecommerce-checkout-fail', component: CheckoutFailed },

  // Purchase
  { path: '/purchase-request', component: PurchaseRequest },
  { path: '/other-purchase-request', component: OtherPurchaseRequest },
  { path: '/create-other-purchase', component: CreateOtherPurchase },

  // Payment
  { path: '/payment-list', component: PaymentList },
  { path: '/create-payment', component: CreatePayment },

  // Admin
  { path: '/admin', component: AdminDashboard, isAdmin: true },

  // Admin > Purchase
  {
    path: '/admin-purchase-request',
    component: AdminPurchaseRequest,
    isAdmin: true,
  },
  {
    path: '/admin-other-purchase-request',
    component: AdminOtherPurchaseRequest,
    isAdmin: true,
  },
  {
    path: '/admin-create-other-purchase',
    component: AdminCreateOtherPurchase,
    isAdmin: true,
  },

  { path: '/about-us', component: AboutUs },
  { path: '/contact-us', component: ContactUs },
  { path: '/privacy-policy', component: PrivacyPolicy },
  { path: '/return-refund-policy', component: ReturnRefundPolicy },
  { path: '/shipping-policy', component: ShippingPolicy },
  { path: '/terms-of-services', component: TermsOfServices },

  // profile
  { path: '/user-profile', component: UserProfile },
];

const publicRoutes = [
  // Home
  { path: '/', component: Home },
  // { path: '/dashboard', component: Home },

  // Error
  { path: '/pages-404', component: Pages404 },

  // authentication
  { path: '/login', component: Login },
  { path: '/logout', component: Logout },
  { path: '/register', component: Register },
  { path: '/oauth2/callback', component: LoginSuccess },

  // 404 catch-all for public routes
  { path: '*', component: Pages404 },
];

export { authProtectedRoutes, publicRoutes };
